import { Attributes, NeoModel, Rules, ValueObject } from "@singularsystems/neo-core";

@NeoModel
export default class LatestBookValueHoldingsReportCriteria extends ValueObject  
{
    @Rules.Required("Broker is required.")
    public StaticServiceProviderFileGroupingID: number = 0;

    public serviceProviderGroupingName: string = "";

    @Attributes.Date()
    public reportDate: Date = new Date();
}